var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorSignIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 142,
    viewBox: "0 0 180 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.7605 122.472C120.754 122.472 144.259 98.9669 144.259 69.8701C144.259 40.7733 120.65 17.2681 91.7605 17.2681C62.7672 17.2681 39.262 40.7733 39.262 69.8701C39.262 98.9669 62.7672 122.472 91.7605 122.472Z",
    fill: "#0078FF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.428 35.4924C142.773 35.4924 144.674 33.5916 144.674 31.2469C144.674 28.9022 142.773 27.0015 140.428 27.0015C138.083 27.0015 136.183 28.9022 136.183 31.2469C136.183 33.5916 138.083 35.4924 140.428 35.4924Z",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.641 18.9246C148.242 18.9246 149.54 17.6266 149.54 16.0253C149.54 14.424 148.242 13.126 146.641 13.126C145.039 13.126 143.741 14.424 143.741 16.0253C143.741 17.6266 145.039 18.9246 146.641 18.9246Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.913 42.7401C36.5143 42.7401 37.8123 41.442 37.8123 39.8407C37.8123 38.2395 36.5143 36.9414 34.913 36.9414C33.3117 36.9414 32.0137 38.2395 32.0137 39.8407C32.0137 41.442 33.3117 42.7401 34.913 42.7401Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8593 123.3C53.8331 123.3 56.2438 120.889 56.2438 117.916C56.2438 114.942 53.8331 112.531 50.8593 112.531C47.8856 112.531 45.4749 114.942 45.4749 117.916C45.4749 120.889 47.8856 123.3 50.8593 123.3Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17074_48512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.306 83.957C157.306 97.3367 146.485 108.157 132.989 108.157C132.757 108.157 130.779 108.157 116.236 108.157C106.114 108.157 89.9416 108.157 64.113 108.157H51.7804C35.6084 108.506 22.6941 95.5915 22.6941 80.0013C22.6941 64.2947 35.7248 51.264 52.1294 52.0784C66.2072 8.0999 130.662 14.2662 136.131 59.7572C148.231 61.2697 157.306 71.5081 157.306 83.957Z",
    fill: "url(#paint0_linear_17074_48512)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.989 108.157C146.369 108.157 157.306 97.3368 157.306 83.9571C157.306 70.5774 146.369 59.7573 132.989 59.7573C119.61 59.7573 108.673 70.5774 108.673 83.9571C108.673 97.3368 119.61 108.157 132.989 108.157Z",
    fill: "url(#paint1_linear_17074_48512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3156 108.39C117.166 108.39 136.596 89.0764 136.596 65.2256C136.596 41.3748 117.166 22.0615 93.3156 22.0615C69.4648 22.0615 50.0352 41.3748 50.0352 65.2256C50.0352 89.0764 69.3485 108.39 93.3156 108.39Z",
    fill: "url(#paint2_linear_17074_48512)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.3207 66.4632L83.3448 64.4345C83.9351 63.8428 83.9351 62.8284 83.3448 62.2367C82.7544 61.645 81.7423 61.645 81.152 62.2367L79.1279 64.2654L77.1038 62.2367C76.5134 61.645 75.5014 61.645 74.911 62.2367C74.3207 62.8284 74.3207 63.8428 74.911 64.4345L76.9351 66.4632L74.911 68.4919C74.3207 69.0836 74.3207 70.0979 74.911 70.6896C75.2484 71.0277 75.5857 71.1122 76.0074 71.1122C76.4291 71.1122 76.7665 70.9432 77.1038 70.6896L79.1279 68.6609L81.152 70.6896C81.4893 71.0277 81.8267 71.1122 82.2484 71.1122C82.6701 71.1122 83.0074 70.9432 83.3448 70.6896C83.9351 70.0979 83.9351 69.0836 83.3448 68.4919L81.3207 66.4632Z",
    fill: "url(#paint3_linear_17074_48512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.791 66.4632L105.04 64.4345C105.696 63.8428 105.696 62.8284 105.04 62.2367C104.384 61.645 103.26 61.645 102.604 62.2367L100.355 64.2654L98.1059 62.2367C97.4499 61.645 96.3254 61.645 95.6695 62.2367C95.0135 62.8284 95.0135 63.8428 95.6695 64.4345L97.9184 66.4632L95.6695 68.4919C95.0135 69.0836 95.0135 70.0979 95.6695 70.6896C96.0443 71.0277 96.4191 71.1122 96.8877 71.1122C97.3562 71.1122 97.731 70.9432 98.1059 70.6896L100.355 68.6609L102.604 70.6896C102.979 71.0277 103.354 71.1122 103.822 71.1122C104.291 71.1122 104.665 70.9432 105.04 70.6896C105.696 70.0979 105.696 69.0836 105.04 68.4919L102.791 66.4632Z",
    fill: "url(#paint4_linear_17074_48512)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1662 25.6056C44.4089 24.6508 45.3797 24.0735 46.3345 24.3162L53.086 26.0323C54.0408 26.275 54.6181 27.2458 54.3754 28.2006C54.1327 29.1555 53.1619 29.7328 52.2071 29.4901L45.4556 27.7739C44.5008 27.5312 43.9235 26.5604 44.1662 25.6056Z",
    fill: "#989FB0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9032 6.61824C50.7183 6.06493 51.8277 6.2772 52.381 7.09234L60.4519 18.9827C61.0052 19.7978 60.7929 20.9072 59.9778 21.4605C59.1626 22.0138 58.0533 21.8015 57.5 20.9864L49.4291 9.09603C48.8757 8.28089 49.088 7.17154 49.9032 6.61824Z",
    fill: "#989FB0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8746 1.2555C65.841 1.06421 66.7796 1.6926 66.9708 2.65904L69.7612 16.7564C69.9525 17.7228 69.3241 18.6613 68.3576 18.8526C67.3912 19.0439 66.4527 18.4155 66.2614 17.4491L63.471 3.35177C63.2797 2.38532 63.9081 1.44679 64.8746 1.2555Z",
    fill: "#989FB0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.6101,
    y: 80.4316,
    width: 23.8159,
    height: 3.10642,
    fill: "url(#paint5_linear_17074_48512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1067 81.4673H97.2486V86.6447C97.2486 87.7884 96.3214 88.7156 95.1776 88.7156C94.0339 88.7156 93.1067 87.7884 93.1067 86.6447V81.4673Z",
    fill: "url(#paint6_linear_17074_48512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.566 35.9731C147.125 37.8335 146.463 39.6223 145.653 41.268C143.519 45.1319 140.355 48.2803 136.382 50.2122C132.261 52.2873 127.405 53.0028 122.475 52.0726C110.996 49.7113 103.564 38.8352 105.992 27.6014C108.42 16.3675 119.531 9.14058 131.084 11.5018C135.204 12.3605 138.81 14.2924 141.827 17.083C146.83 22.0917 148.964 29.1755 147.566 35.9731Z",
    fill: "url(#paint7_linear_17074_48512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.679 21.5578L123.679 21.5578L123.68 21.5658L124.521 32.0003C124.592 33.2354 125.543 34.3353 126.76 34.3353C127.976 34.3353 128.928 33.2354 128.998 32.0003L129.839 21.5658L129.839 21.5658L129.84 21.5567C129.965 19.538 128.632 17.8032 126.76 17.8032C124.882 17.8032 123.554 19.6091 123.679 21.5578Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.76 38.5127C125.045 38.5127 123.671 39.8871 123.671 41.6014C123.671 43.3157 125.045 44.6901 126.76 44.6901C128.474 44.6901 129.848 43.3157 129.848 41.6014C129.848 39.8871 128.474 38.5127 126.76 38.5127Z",
    fill: "white",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17074_48512",
    x: 0.694092,
    y: 11.1665,
    width: 178.612,
    height: 129.997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17074_48512"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17074_48512",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17074_48512",
    x1: 89.9998,
    y1: 57.7039,
    x2: 89.9559,
    y2: 109.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17074_48512",
    x1: 106.086,
    y1: 54.5472,
    x2: 127.642,
    y2: 78.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2B3CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17074_48512",
    x1: 45.9824,
    y1: 45.4188,
    x2: 79.9566,
    y2: 58.7139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17074_48512",
    x1: 84.005,
    y1: 64.2412,
    x2: 74.1351,
    y2: 65.0081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#246CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#1E68F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17074_48512",
    x1: 105.774,
    y1: 64.2412,
    x2: 94.8228,
    y2: 65.1866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#246CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#1E68F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_17074_48512",
    x1: 102.982,
    y1: 81.2477,
    x2: 84.2518,
    y2: 92.4042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#246CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#1E68F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_17074_48512",
    x1: 97.3452,
    y1: 83.3715,
    x2: 92.9408,
    y2: 83.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#246CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#1E68F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_17074_48512",
    x1: 105.513,
    y1: 31.7687,
    x2: 147.994,
    y2: 31.7687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSignIcon);
export default __webpack_public_path__ + "static/media/ErrorSignIcon.9a57759d.svg";
export { ForwardRef as ReactComponent };